import api from "@/services/api"

type LogInAsServiceLogisticsRequest = {
  pin: string
}

type LogInAsServiceLogisticsResponse = {
  authorised: true
}

export const logInAsServiceLogistics = async (
  request: LogInAsServiceLogisticsRequest
): Promise<LogInAsServiceLogisticsResponse> => {
  const { body } =
    await api.post<LogInAsServiceLogisticsResponse>(
      "/auth/app/service-logistics-login/",
      { body: request }
    )

  return body
}
